<template>
  <div></div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import SurveyUtils from '@/utils/survey'
import { PUBLIC_ROUTES } from '@/constant/routes'

export default {
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    ...mapGetters(['isEURegion']),
    isPublicRouteName() { // for more readable code than isInvalidTokenModalVisible
      const routeName = this.$route && this.$route.name
      return PUBLIC_ROUTES.includes(routeName)
    },
  },
  watch: {
    $route: async function checkRouteChange(to) {
      if (this.isPublicRouteName || this.isEURegion) return
      if (!SurveyUtils.alreadyHasSurveyScript()) {
        await SurveyUtils.initActiveSurveyData()
      }
      SurveyUtils.checkToShowSurveyOnAPage(to.path)
    },
  },
  async created() {
    if (this.isPublicRouteName || this.isEURegion) return
    await SurveyUtils.initActiveSurveyData()
    SurveyUtils.checkToShowSurveyOnAPage(this.$route.path)
    window.getSurveyAndCheckVisibilityBySurveyCode = SurveyUtils.getSurveyAndCheckVisibilityBySurveyCode
  },
  beforeDestroy() {
    // Clean up to avoid memory leaks
    delete window.getSurveyAndCheckVisibilityBySurveyCode
  },
}
</script>
